import {
  AddSessionRequest,
  BackgroundResponse,
  PartialUpdateSessionRequest,
  SessionCollection,
  SessionDetails,
  SessionEndDetails,
  SessionEndPageDetails,
  SessionWelcomeDetails,
  SessionWelcomePageDetails,
  SetBackgroundRequest,
  SetSessionEndRequest,
  SetSessionWelcomeRequest,
  ShowingDetails
} from '../models/api';
import api, { deleteData, getData, patchData, postData, putData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const list = async (): Promise<ResponseData<SessionCollection>> =>
  getData<SessionCollection>('api/sessions');
export const get = async (
  sessionReference: string
): Promise<ResponseData<SessionDetails>> =>
  getData<SessionDetails>(`api/sessions/${sessionReference}`);
export const add = async (
  model: AddSessionRequest
): Promise<ResponseData<SessionDetails>> =>
  postData<SessionDetails>('api/sessions', model);
export const update = async (
  sessionReference: string,
  model: AddSessionRequest
): Promise<ResponseData<SessionDetails>> =>
  putData<SessionDetails>(`api/sessions/${sessionReference}`, model);
export const partialUpdate = async (
  sessionReference: string,
  model: PartialUpdateSessionRequest
): Promise<ResponseData<SessionDetails>> =>
  patchData<SessionDetails>(`api/sessions/${sessionReference}`, model);
export const remove = async (
  sessionReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  deleteData(`api/sessions/${sessionReference}`);
export const getQR = async (
  sessionReference: string,
  showingReference?: string | null
): Promise<Blob> => {
  if (showingReference) {
    return (
      await api.get(`api/sessions/${sessionReference}/qr/${showingReference}`, {
        responseType: 'blob'
      })
    ).data;
  }
  return (
    await api.get(`api/sessions/${sessionReference}/qr`, {
      responseType: 'blob'
    })
  ).data;
};
export const createPreview = async (
  sessionReference: string
): Promise<ResponseData<ShowingDetails>> =>
  await postData<ShowingDetails>(
    `api/sessions/${sessionReference}/preview`,
    {}
  );
export const getPreview = async (
  sessionReference: string,
  showingReference: string
): Promise<ResponseData<ShowingDetails>> =>
  await getData<ShowingDetails>(
    `api/sessions/${sessionReference}/preview/${showingReference}`
  );

export const getBackground = async (
  sessionReference: string
): Promise<ResponseData<BackgroundResponse>> =>
  await getData<BackgroundResponse>(
    `api/sessions/${sessionReference}/background`
  );

export const removeBackground = async (
  sessionReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  await deleteData(`api/sessions/${sessionReference}/background`);

export const setBackground = async (
  sessionReference: string,
  model: SetBackgroundRequest
): Promise<ResponseData<BackgroundResponse>> =>
  await putData<BackgroundResponse>(
    `api/sessions/${sessionReference}/background`,
    model
  );

export const getWelcome = async (
  sessionReference: string
): Promise<ResponseData<SessionWelcomeDetails>> =>
  await getData<SessionWelcomeDetails>(
    `api/sessions/${sessionReference}/welcome`
  );

export const updateWelcome = async (
  sessionReference: string,
  request: SetSessionWelcomeRequest
): Promise<ResponseData<SessionWelcomeDetails>> =>
  await putData<SessionWelcomeDetails>(
    `api/sessions/${sessionReference}/welcome`,
    request
  );

export const getWelcomePage = async (
  sessionReference: string
): Promise<ResponseData<SessionWelcomePageDetails>> =>
  await getData<SessionWelcomePageDetails>(
    `api/sessions/${sessionReference}/welcome/page`
  );

export const getEnd = async (
  sessionReference: string
): Promise<ResponseData<SessionEndDetails>> =>
  await getData<SessionEndDetails>(`api/sessions/${sessionReference}/End`);

export const updateEnd = async (
  sessionReference: string,
  request: SetSessionEndRequest
): Promise<ResponseData<SessionEndDetails>> =>
  await putData<SessionEndDetails>(
    `api/sessions/${sessionReference}/End`,
    request
  );

export const getEndPage = async (
  sessionReference: string
): Promise<ResponseData<SessionEndPageDetails>> =>
  await getData<SessionEndPageDetails>(
    `api/sessions/${sessionReference}/End/page`
  );
